export const currencySymbols = {
  usd: "$",
  eur: "€",
  aud: "A$",
};

export function getCurrencySymbol(currencyCode) {
  return currencySymbols[currencyCode] || currencyCode;
}
